<!-- Translated: yes -->
<template>
  <div :class="'variant--' + variant">
    <div class="more-details" v-if="types.indexOf('rental') !== -1 && extradetails('rental').length" v-show="openRental">
      <div v-for="(person, k) in extradetails('rental')" :key="k" class="person">
        <div class="th">{{ Object.values(person)[0][0].skiername }}</div>
        <div v-for="(detail, kk) in Object.values(person)" :key="'d' + kk" class="td">
          <div class="details">
            <div v-for="(detail2, kkk) in detail" :key="'d2' + kkk">{{ detail2.productname }}, {{ (detail2.skierage || '').toLowerCase() }}</div>
            <div class="text-sm" v-if="skierAttributes(detail[0])">{{ skierAttributes(detail[0]) }}</div>            
          </div>

          <div class="date">
            <div class="text-sm">{{ detail[0].arrival }}</div>
            <div class="text-sm" style="margin-top:0.25rem;" v-if="detail[0].days">{{ detail[0].days }} dagar</div>
          </div>
        </div>
      </div>

      <!-- Book more -->
      <div class="person">
        <div class="th">&nbsp;</div>
        <div class="td">
          <div class="details">
            <button class="button--rounded--outlined" @click.stop="bookMore('rental')">Boka mer</button>
          </div>
          <div class="date">&nbsp;</div>
        </div>
      </div>
      <!-- ./ Book more -->
    </div>

    <div class="more-details" v-if="types.indexOf('skipass') !== -1 && extradetails('skipass').length" v-show="openSkipass">
      <div v-for="(person, k) in extradetails('skipass')" :key="k" class="person">
        <div class="th">{{ Object.values(person)[0][0].skiername }}</div>
        <div v-for="(detail, kk) in Object.values(person)" :key="'d' + kk" class="td">
          <div class="details">
            <div v-for="(detail2, kkk) in detail" :key="'d2' + kkk">{{ detail2.name }}</div>
          </div>

          <div class="date">
            <div class="text-sm">{{ detail[0].arrival }}</div>
          </div>
        </div>
      </div>

      <!-- Book more -->
      <div class="person">
        <div class="th">&nbsp;</div>
        <div class="td">
          <div class="details">
            <button class="button--rounded--outlined" @click.stop="bookMore('skipass')">Boka mer</button>
          </div>
          <div class="date">&nbsp;</div>
        </div>
      </div>
      <!-- ./ Book more -->
    </div>

    <div class="more-details" v-if="types.indexOf('skischool') !== -1 && extradetails('skischool').length" v-show="openSkischool">
      <div v-for="(person, k) in extradetails('skischool')" :key="k" class="person">
        <div class="th">{{ Object.values(person)[0][0].skiername }}</div>
        <div v-for="(detail, kk) in Object.values(person)" :key="'d' + kk" class="td">
          <div class="details">
            <div v-for="(detail2, kkk) in detail" :key="'d2' + kkk">{{ detail2.name }}</div>
            <div class="text-sm" v-if="schoolerAttributes(detail[0])">{{ schoolerAttributes(detail[0]) }}</div>
          </div>

          <div class="date">
            <div class="text-sm">{{ detail[0].arrival }}</div>
          </div>
        </div>
      </div>

      <!-- Book more -->
      <div class="person">
        <div class="th">&nbsp;</div>
        <div class="td">
          <div class="details">
            <button class="button--rounded--outlined" @click.stop="bookMore('skischool')">Boka mer</button>
          </div>
          <div class="date">&nbsp;</div>
        </div>
      </div>
      <!-- ./ Book more -->
    </div>
  </div>
</template>

<script>
import myOrder from '@/mixins/my-order'; // eslint-disable-line

export default {
  props: {
    order: {
      default: {},
    },
    types: {
      default: [],
    },
    variant: {
      default: 'normal',
    },
    openRental: {
      default: false,
    },
    openSkipass: {
      default: false,
    },
    openSkischool: {
      default: false,
    },
    bookMoreCallback: {
      default: () => {},
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  mixins: [myOrder],
  methods: {
    bookMore(bookingType) {
      this.bookMoreCallback(bookingType, this.order);
    },
  },
  computed: {
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'
@import '~@/global-v2.styl'

.variant--normal
  --name-size: 180px
  --date-size: 140px
  --content-wrapper-size: calc(100% - var(--name-size))
  --content-size: calc(100% - var(--date-size))
  --name-align: right
  --date-padding-right: 4rem
  --name-padding-left: 1rem
.variant--mini
  --name-size: 120px
  --date-size: 140px
  --content-wrapper-size: calc(100% - var(--name-size))
  --content-size: calc(100% - var(--date-size))
  --name-align: left
  --date-padding-right: 0
  --name-padding-left: 2.25rem

.more-details
  barlow()
  font-size 1rem
  width 100%
  .person
    display flex
    // border-top 1px solid shadow-blue
    padding 0.5rem 1rem
    width 100%
    justify-content: space-between
    @media (max-width: 650px)
      flex-direction: column
    .th
      text-align var(--name-align)
      vertical-align top
      width var(--name-size)
      padding 0.5rem 1rem
      padding-right 0
      padding-left var(--name-padding-left)
      font-weight bold
      @media (max-width: 650px)
        width 100%
        padding-left 0
        padding-right 0
        text-align left
    .td
      text-align: left
      padding 0.5rem 1rem
      width var(--content-wrapper-size)
      display flex
      @media (max-width: 650px)
        width 100%
        padding-left 0
        padding-right 0
        text-align left
        flex-direction column
      .details
        text-align left
        width var(--content-size)
        padding-left 2rem
        @media (max-width: 650px)
          width 100%
          padding-left 0
          padding-right 0
          text-align left
        .text-sm
          margin-top 0.75rem
      .date
        width var(--date-size)
        text-align right
        padding-left 0
        padding-right var(--date-padding-right)
        @media (max-width: 650px)
          margin-top 0.5rem
          width 100%
          padding-left 0
          padding-right 0
          text-align left
</style>



// WEBPACK FOOTER //
// PrettyOrderDetails.vue?b3071cae